// extracted by mini-css-extract-plugin
module.exports = {"root":"SegmentedControl_root__NWm4x","indicator":"SegmentedControl_indicator__2y73K","radio":"SegmentedControl_radio__x1a2_","item":"SegmentedControl_item__qAfSj"};